<template>
  <b-table :data="stockouts" hoverable style="cursor: pointer">
    <b-table-column
      field="createdAt"
      :label="$t('stockouts.date')"
      v-slot="props"
      sortable
    >
      {{
        moment
          .utc(props.row.createdAt)
          .add(preferences.timezone, "h")
          .format("DD/MM/YY HH:mm:ss")
      }}
    </b-table-column>

    <b-table-column
      field="store.storeInfo.name"
      :label="$t('stockouts.store')"
      v-slot="props"
      sortable
    >
      {{ props.row.store.storeInfo.name }}
    </b-table-column>

    <b-table-column
      field="product.b"
      :label="$t('stockouts.barcode')"
      v-slot="props"
      sortable
    >
      {{ props.row.product.b }}
    </b-table-column>

    <b-table-column
      field="product.n"
      :label="$t('stockouts.product')"
      v-slot="props"
      sortable
    >
      {{ props.row.product.n }}
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  mixins: [common],

  props: ["stockouts"],

  components: {
    tableEmptyTemplate
  },

  computed: {
    ...mapGetters(["preferences"])
  }
};
</script>

<style>
.adjust-top {
  position: relative;
  top: 8px;
}
</style>
